module.exports = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_pipe.js
// module id = 501
// module chunks = 0